<template>
  <div class="homeContent">
    <!-- 顶部区域：用户信息 + 数据卡片 + 时钟 -->
    <div class="top-section">
      <div class="user-info-card">
        <User></User>
      </div>
      <div class="data-cards-grid">
        <div class="cardRow">
          <numberCard explain="儿科" number="726" role="yiyuan" class="data-card"></numberCard>
          <numberCard explain="妇科" number="985" role="yiyuanjieshaobeifen" class="data-card"></numberCard>
          <numberCard explain="中医内科" number="1232" role="yiyuan1" class="data-card"></numberCard>
        </div>
       <div class="cardRow">
         <numberCard explain="皮肤科" number="821" role="yiyuan2" class="data-card"></numberCard>
         <numberCard explain="针灸推拿科" number="686" role="yiyuanzixun" class="data-card"></numberCard>
         <numberCard explain="治未病科" number="923" role="yiyuanguanjia_yinshianpai" class="data-card"></numberCard>
       </div>
      </div>
      <div class="clock-card">
        <Clock></Clock>
      </div>
    </div>
    
    <!-- 底部区域：饼图 + 轮播图 -->
    <div class="bottom-section">
      <div class="chart-card">
        <PieChart></PieChart>
      </div>
      <div class="rotation-card">
        <Rotation></Rotation>
      </div>
    </div>
  </div>
</template>

<script>
import User from '../components/user'
import Clock from "../components/clock";
import NumberCard from "../components/NumberCard";
import Columnar from "../components/Columnar";
import PieChart from "../components/PieChart";
import Rotation from "../components/Rotation";

export default {
  name: "Index",

  components: {
    Clock,
    User,
    NumberCard,
    Columnar,
    PieChart,
    Rotation
  },

  data() {
    return {
      hospitalInfo: null
    }
  },
  created() {
    this.hospitalInfo = JSON.parse(sessionStorage.getItem('User')) || null;
  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.homeContent {
  height: calc(100vh - 42px - 70px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
  justify-content: center;
  gap: 3.25rem;
  padding: 2.5rem;
  .top-section{
    display: flex;
    align-items: flex-end;
    width: 100%;
    height: 17rem;
    padding-left: 2.5rem;
    gap: 1.25rem;
    .user-info-card{
      height: 14rem;
    }
    .data-cards-grid{
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      gap: 15px;
      width: 39rem;
      height: 16rem;
      .cardRow {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 20px;
        height: 40%;
        width: 100%;
      }
    }
    .clock-card {
      position: absolute;
      margin-left: 10.2rem;
      right: 1rem;
    }
  }
  .bottom-section{
    display: flex;
    align-items: center;
    gap: 20px;
    width: 100%;
    flex: 1;
    padding-bottom: 60px;
    .chart-card{
      width: 50%;
      height: 100%;
    }
    .rotation-card {
      width: 50%;
      height: 100%;
    }
  }
}
</style>
